import { useSelector } from "react-redux";
import EventsPrincipal from "./principal/EventsPrincipal.js";
import EventsOthers from "./EventsOthers.js";
import Loader from "./Loader.js";

function Dashboard() {
  const state = useSelector((state) => state);
  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <EventsPrincipal />;
    }
    return <EventsOthers />;
  }
}

export default Dashboard;
